import gql from "graphql-tag";

export default gql`
	mutation deleteAllPermissionsForClient($userId: ID!, $clientId: ID!) {
		deleteAllPermissionsForClient(userId: $userId, clientId: $clientId)
	}
`;
